import { render, staticRenderFns } from "./wizard-complete.vue?vue&type=template&id=a7335b52&scoped=true&lang=pug"
import script from "./wizard-complete.vue?vue&type=script&lang=ts"
export * from "./wizard-complete.vue?vue&type=script&lang=ts"
import style0 from "./wizard-complete.vue?vue&type=style&index=0&id=a7335b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7335b52",
  null
  
)

export default component.exports